var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('router-view'),(_vm.dialog)?_c('Dialog',{attrs:{"message":_vm.dialogMessage,"icon":_vm.dialogIcon}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }